import { Behavior } from '@babylonjs/core/Behaviors/behavior';
import { Node } from '@babylonjs/core/node';

import ArticleNode from './articleNode';

export const ARTICLE_CHILD_NODE_NAME = 'ArticleChildNode';
export default class ArticleChildNode implements Behavior<Node> {
  name = ARTICLE_CHILD_NODE_NAME;
  readonly parentArticle: ArticleNode;

  constructor(parent: ArticleNode) {
    this.parentArticle = parent;
  }

  init(): void {}

  attach(target: Node): void {}

  detach(): void {}
}
